module.exports = __webpack_public_path__ + "img/SportBiz.52c7cbcb.png";